export const DEFAULT_ERROR_MESSAGE = "*We could not complete your action. Please contact your Health System.";
